import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { IQuestionnaireBO, IQuestionnaireEvaluationBO } from '@mapfre-tech/amap3';
import * as _ from 'lodash';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  className = 'QuestionnaireService';

  constructor(private http: HttpClient, private router: Router) { }

  getAllQuestionnaires(questionnaireTypeIds: number[] | null = null): Observable<IQuestionnaireEvaluationBO[]> {
    const params: any = {};
    if (questionnaireTypeIds) {
      params.questionnaireTypeIds = questionnaireTypeIds;
    }

    return this.http.get<IQuestionnaireEvaluationBO[]>(environment.base_URL + "/questionnaires", { params }).pipe(map(res => {
      return _.map(res, (q: any) => {
        let totalValoration = 0;
        let totalNumerableQuestions = 0;
        _.forEach(q.evaluations, (e) => {
          const question = _.get(e, 'questionnaireQuestion.question');
          const isNumerable = _.get(question, 'optionQuestion');
          const valoration = _.get(e, 'mumEvaluationValue', 0);
          if (isNumerable) {
            totalNumerableQuestions++;
            totalValoration += valoration;
          }
        })
        q.evaluations = _.sortBy(q.evaluations, (e) => {
          return _.get(e, 'questionnaireQuestion.nmrOrder');
        });
        q.valoration = totalNumerableQuestions ? (totalValoration / totalNumerableQuestions).toFixed(2) : 0;
        return q;
      })
    }));
  }

  getIsRead() {
    return of([
      { name: 'FILTERS.YES', value: true },
      { name: 'FILTERS.NO', value: false }
    ]);
  }

  getIsComplete() {
    return of([
      { name: 'FILTERS.YES', value: true },
      { name: 'FILTERS.NO', value: false }
    ]);
  }

  getValoration() {
    return of([
      { name: 1, value: 1 },
      { name: 2, value: 2 },
      { name: 3, value: 3 },
      { name: 4, value: 4 },
      { name: 5, value: 5 }
    ]);
  }

  getEvaluationsFiltered(jobId = null, questionnaireTypeIds: number[] | null = null, exercises: number[] | null = null, evaluator = null): Observable<IQuestionnaireEvaluationBO[]> {
    const params: any = {};
    if (jobId) {
      params.jobId = jobId;
    }
    if (questionnaireTypeIds) {
      params.questionnaireTypeIds = questionnaireTypeIds.join(',');
    }
    if (exercises) {
      params.exercises = exercises.join(',');
    }
    if (evaluator) {
      params.evaluator = evaluator;
    }

    return this.http.get<IQuestionnaireEvaluationBO[]>(environment.base_URL + "/evaluations", { params }).pipe(map(res => {
      return _.map(res, (q: any) => {
        let totalValoration = 0;
        let totalNumerableQuestions = 0;
        _.forEach(q.answers, (e) => {
          const question = _.get(e, 'question');
          const isNumerable = _.get(question, 'optionQuestion');
          const valoration = _.get(e, 'mumEvaluationValue', 0);
          if (isNumerable) {
            totalNumerableQuestions++;
            totalValoration += valoration;
          }
        })
        q.evaluations = _.sortBy(q.evaluations, (e) => {
          return _.get(e, 'question.nmrOrder');
        });
        q.questionnaire.valoration = totalNumerableQuestions ? (totalValoration / totalNumerableQuestions).toFixed(2) : 0;
        return q;
      })
    }));
  }

  getQuestionnaireById(id: number): Observable<IQuestionnaireBO> {
    return this.http.get<IQuestionnaireBO>(environment.base_URL + `/questionnaires/${id}`);
  }

  newQuestionnaire(assessment: IQuestionnaireBO): Observable<IQuestionnaireBO[]> {
    return this.http.post<IQuestionnaireBO[]>(environment.base_URL + "/questionnaires", assessment);
  }

  newEvaluation(evaluation: IQuestionnaireEvaluationBO): Observable<IQuestionnaireEvaluationBO[]> {
    return this.http.post<IQuestionnaireEvaluationBO[]>(environment.base_URL + "/evaluations", evaluation);
  }

  updateQuestionnaire(assessment: IQuestionnaireBO, id: number): Observable<IQuestionnaireBO[]> {
    return this.http.put<IQuestionnaireBO[]>(environment.base_URL + `/questionnaires/${id}`, assessment)
  }

  deleteQuestionnaire(id: number): Observable<IQuestionnaireBO[]> {
    return this.http.delete<IQuestionnaireBO[]>(environment.base_URL + `/questionnaires/${id}`);
  }

}
